import React from 'react';
import {
  Box,
  Card,
  CardContent,
  CardHeader,
  MenuItem,
  Select,
  Typography,
} from '@mui/material';

export default function UserAccessHistoryCard({
  sessoesUnicas,
  isLoadingHistory,
  filtroPeriodo,
  setFiltroPeriodo,
}) {
  return (
    <Card
      sx={{
        bgcolor: '#2C2C2F',
        color: '#fff',
        p: 0,
        borderRadius: 3,
        maxHeight: '40vh',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <CardHeader
        title="Histórico"
        sx={{
          borderBottom: '1px solid #444',
          pb: 1,
          '& .MuiTypography-root': {
            fontSize: '1.1rem',
            fontWeight: 'bold',
            color: '#ffffff',
          },
        }}
        action={
          <Select
            value={filtroPeriodo}
            onChange={(e) => setFiltroPeriodo(e.target.value)}
            size="small"
            sx={{
              bgcolor: '#3A3A3D',
              color: '#fff',
              minWidth: 90,
              fontSize: '0.875rem',
              '& .MuiSelect-select': { py: 0.9, px: 1.8 },
              '.MuiOutlinedInput-notchedOutline': { borderColor: '#555' },
              '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                borderColor: '#fff',
              },
              '& .MuiSvgIcon-root': { color: '#fff' },
            }}
          >
            <MenuItem value="dia">Dia</MenuItem>
            <MenuItem value="semana">Semana</MenuItem>
            <MenuItem value="mes">Mês</MenuItem>
          </Select>
        }
      />
      <CardContent
        sx={{
          pt: 2,
          '&:last-child': { pb: 2 },
          // FIX: Remover minHeight fixo e usar flex para ocupar espaço disponível
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
        }}
      >
        {isLoadingHistory ? (
          <Typography variant="body2">Carregando histórico...</Typography>
        ) : (
          <Box
            sx={{
              // FIX: Ajustar maxHeight dinamicamente para ocupar o espaço restante
              maxHeight: '100%',
              overflowY: 'auto',
              pr: 1,
              '&::-webkit-scrollbar': { width: '8px' },
              '&::-webkit-scrollbar-track': { backgroundColor: '#3A3A3D' },
              '&::-webkit-scrollbar-thumb': {
                backgroundColor: '#555',
                borderRadius: '4px',
              },
              '&::-webkit-scrollbar-thumb:hover': {
                backgroundColor: '#777',
              },
            }}
          >
            {sessoesUnicas.length === 0 ? (
              <Typography variant="body2" color="text.secondary">
                Nenhuma sessão encontrada.
              </Typography>
            ) : (
              sessoesUnicas.map((sessao, index) => (
                <Box
                  key={sessao.id || `${sessao.inicio}-${index}`}
                  sx={{
                    p: 1.5,
                    mb: 1,
                    border: '1px solid #444',
                    borderRadius: 2,
                    bgcolor: '#3A3A3D',
                  }}
                >
                  <Typography variant="body2" sx={{ lineHeight: 1.4 }}>
                    <strong>Início:</strong> {sessao.inicio}
                  </Typography>
                  <Typography variant="body2" sx={{ lineHeight: 1.4 }}>
                    <strong>Fim:</strong> {sessao.fim}
                  </Typography>
                  <Typography variant="body2" sx={{ lineHeight: 1.4 }}>
                    <strong>Duração:</strong> {sessao.duracao}
                  </Typography>
                </Box>
              ))
            )}
          </Box>
        )}
      </CardContent>
    </Card>
  );
}
